import type { ReportSection } from '@neo/blocks/sidebar/app-sidebar-reports'
import { useMemo } from 'react'
import { useProfileQuery } from 'v2/pages/settings/queries'
import { useFeatureFlags } from 'v2/shared/hooks/use-feature-flags'
import { usePermissions } from 'v2/shared/hooks/use-permissions'
import { getReportSections } from '../report-sections'

// The sections from the same inputs useRoutes builds route meta from, so the sidebar and the
// /analytics landing show exactly what the route gate allows.
export const useReportSections = (): ReportSection[] => {
  const { data: profileData } = useProfileQuery()
  const featureFlags = useFeatureFlags()
  const { permissions } = usePermissions()
  return useMemo(
    () => getReportSections({ profileData, featureFlags, permissionsMap: permissions }),
    [profileData, featureFlags, permissions],
  )
}
